// Package imports:
import React from 'react';

// Component imports:
import Entrypoint from '../Entrypoint';
import NoAccessPage from '../../components/DueDiligence/NoAccessPage';

const NoAccess: React.FC = () => {
    return (
        <Entrypoint>
            <NoAccessPage />
        </Entrypoint>
    );
}

export default NoAccess;